import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { Provider } from 'react-redux';
import store, { useAppSelector, useAppDispatch } from './store';
import { useAppTheme } from './hooks/useAppTheme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Alert, CssBaseline, Snackbar } from '@mui/material';
import { selectBackgroundProcessingStatus, selectPendingNotification } from './store/selectors';
import { setPendingNotification } from './store/slices/processingSlice';
import { BackgroundProcessingIndicator } from './components/CaseManagement';

function AppContent() {
  const { theme } = useAppTheme();
  const dispatch = useAppDispatch();
  const backgroundProcessingStatus = useAppSelector(selectBackgroundProcessingStatus);
  const pendingNotification = useAppSelector(selectPendingNotification);

  const handleCloseNotification = () => {
    dispatch(setPendingNotification(null));
  };

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
      {backgroundProcessingStatus && (
        <BackgroundProcessingIndicator status={backgroundProcessingStatus} />
      )}
      <Snackbar
        open={pendingNotification !== null}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={pendingNotification?.severity ?? 'info'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {pendingNotification?.message}
        </Alert>
      </Snackbar>
    </MuiThemeProvider>
  );
}

function App() {
  return(
    <Provider store={store}>
      <AppContent />
    </Provider>
  ) 
}

export default App;